import React from "react"
import {
  Navbar,
  Container,
  NavDropdown,
  NavItem,
  ListGroup,
  Row,
  Col,
  Sonnet,
  Tab,
} from "react-bootstrap"
import { Link } from "gatsby"
import "../../styles/home.scss"
import "bootstrap/dist/css/bootstrap.css"
import Logo from "../../images/site-logo.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"

const Header = () => {
  return (
    <header>
      <Navbar expand="lg" className="navigation-bar py-2">
        <Container>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Brand style={{ margin: "0 auto" }}>
            <Link to="/">
              <a>
                <img src={Logo} className="img-fluid my-auto" />
              </a>
            </Link>
          </Navbar.Brand>
          <div className="search-md">
            <FontAwesomeIcon icon={faSearch} />
          </div>
          {/* <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button> */}
          <Navbar.Collapse className="justify-content-end" id="navbarNav">
            <ul className="navbar-nav navbar-right navmanu">
              <li className="dropdown nav-item my-auto">
                <NavDropdown title="KNOWLEDGE HUB" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/knowledge-base/addiction">
                    Addiction Hub
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/knowledge-base/treatment">
                    Treatment Hub
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/knowledge-base/substance">
                    Substance Hub
                  </NavDropdown.Item>
                  {/* <Tab.Container
                    id="list-group-tabs-example"
                    defaultActiveKey="#link1"
                  >
                    <Row>
                      <Col sm={4}>
                        <ListGroup>
                          <ListGroup.Item action href="#link1">
                            Link 1
                          </ListGroup.Item>
                          <ListGroup.Item action href="#link2">
                            Link 2
                          </ListGroup.Item>
                        </ListGroup>
                      </Col>
                      <Col sm={8}>
                        <Tab.Content>
                          <Tab.Pane eventKey="#link1">
                            <Sonnet />
                          </Tab.Pane>
                          <Tab.Pane eventKey="#link2">
                            <Sonnet />
                          </Tab.Pane>
                        </Tab.Content>
                      </Col>
                    </Row>
                  </Tab.Container> */}
                </NavDropdown>
              </li>
              {/* <li className="nav-item my-auto">
                <Link to="/knowledge-base">
                  <a className="nav-link">KNOWLEDGE BASE</a>
                </Link>
              </li>
 */}
              <li className="nav-item my-auto">
                <Link to="/help-center">
                  <a className="nav-link">HELP CENTER</a>
                </Link>
              </li>
              {/* <li className="nav-item my-auto">
                <Link to="/Addiction-Help-Centres">
                  <a className="nav-link">ADDICTION REHABS</a>
                </Link>
              </li> */}
              {/* <li className="dropdown nav-item my-auto">
                <NavDropdown title="HELP CENTER" id="basic-nav-dropdown">
                  <Link to="/">
                    <NavDropdown.Item>Action</NavDropdown.Item>
                  </Link>
                  <Link to="/">
                    <NavDropdown.Item>Another action</NavDropdown.Item>
                  </Link>
                  <Link to="/">
                    <NavDropdown.Item>Something</NavDropdown.Item>
                  </Link>
                </NavDropdown>
              </li> */}
              {/* <li className="nav-item my-auto">
                <Link to="/self-assessment-quizzes">
                  <a className="nav-link">QUIZZES</a>
                </Link>
              </li> */}
              <li className="nav-item my-auto">
                <Link to="/FAQs">
                  <a className="nav-link">FAQ</a>
                </Link>
              </li>
              <li className="nav-item my-auto">
                <Link to="/community">
                  <a className="nav-link">COMMUNITY</a>
                </Link>
              </li>
              <li className="nav-item my-auto">
                <Link to="/contact-us">
                  <a className="nav-link">CONTACT US</a>
                </Link>
              </li>
              <li className="nav-item my-auto">
                <Link to="/">
                  <button className="login-btn btn">LOG IN</button>
                </Link>
              </li>
            </ul>
          </Navbar.Collapse>
          <div className="pl-4 search-lg">
            <FontAwesomeIcon icon={faSearch} />
          </div>
        </Container>
      </Navbar>
    </header>
  )
}

export default Header
